import { EmailInputControl } from 'common';
import styled from 'styled-components';

export const StyledEmailInputControl = styled(EmailInputControl)`
    width: 660px;
    .ap-tagInput-tagLabel {
        max-width: unset;
    }
`;
